import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ResultFinal() {
  return (
    <section className="result_nurs p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="m-auto">
            <h2>
              The <span style={{ color: "#198463" }}>Results</span>
            </h2>
            <p>
              The end result of this application is an intuitive design, a
              user-friendly mobile application that enables online shoppers to
              compare and contrast distinct products’ features and prices and
              shop for their favorite products hassle-free.
            </p>
            <p>
              Due to the building of this application, users don’t need to visit
              stores separately to buy their favorite products/goods. To sum up,
              the purpose of this application is to provide users with a
              seamless shopping experience in one place without any hassle.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center my-auto offset-xl-1"
          >
            <StaticImage
              src="../../../images/case-studies/save-win/tek_img_07.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={745}
              height={735}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ResultFinal;
